import { DataProvider } from "react-admin";
import NotImplementedError from "./NotImplementedError";
import { AdminResource } from "./resource/resource";
import organizationDataProvider from "./resource/organization/dataProvider";
import userDataProvider from "./resource/user/dataProvider";
import resultDataProvider from "./resource/result/dataProvider";

const dataProvider: DataProvider = {
  getList: async (resource, params) => {
    switch (resource) {
      case AdminResource.organizations:
        return organizationDataProvider.getList(resource, params);
      case AdminResource.users:
        return userDataProvider.getList(resource, params);
      case AdminResource.results:
        return resultDataProvider.getList(resource, params);
      default:
        throw NotImplementedError;
    }
  },
  getOne: async (resource, params) => {
    switch (resource) {
      case AdminResource.organizations:
        return organizationDataProvider.getOne(resource, params);
      case AdminResource.users:
        return userDataProvider.getOne(resource, params);
      case AdminResource.results:
        return resultDataProvider.getOne(resource, params);
      default:
        throw NotImplementedError;
    }
  },
  getMany: async (resource, params) => {
    switch (resource) {
      case AdminResource.organizations:
        return organizationDataProvider.getMany(resource, params);
      case AdminResource.users:
        return userDataProvider.getMany(resource, params);
      case AdminResource.results:
        return resultDataProvider.getMany(resource, params);
      default:
        throw NotImplementedError;
    }
  },
  getManyReference: async (resource, params) => {
    switch (resource) {
      case AdminResource.organizations:
        return organizationDataProvider.getManyReference(resource, params);
      case AdminResource.users:
        return userDataProvider.getManyReference(resource, params);
      case AdminResource.results:
        return resultDataProvider.getManyReference(resource, params);
      default:
        throw NotImplementedError;
    }
  },
  create: async (resource, params) => {
    switch (resource) {
      case AdminResource.organizations:
        return organizationDataProvider.create(resource, params);
      case AdminResource.users:
        return userDataProvider.create(resource, params);
      case AdminResource.results:
        return resultDataProvider.create(resource, params);
      default:
        throw NotImplementedError;
    }
  },
  update: async (resource, params) => {
    switch (resource) {
      case AdminResource.organizations:
        return organizationDataProvider.update(resource, params);
      case AdminResource.users:
        return userDataProvider.update(resource, params);
      case AdminResource.results:
        return resultDataProvider.update(resource, params);
      default:
        throw NotImplementedError;
    }
  },
  updateMany: async (resource, params) => {
    switch (resource) {
      case AdminResource.organizations:
        return organizationDataProvider.updateMany(resource, params);
      case AdminResource.users:
        return userDataProvider.updateMany(resource, params);
      case AdminResource.results:
        return resultDataProvider.updateMany(resource, params);
      default:
        throw NotImplementedError;
    }
  },
  delete: async (resource, params) => {
    switch (resource) {
      case AdminResource.organizations:
        return organizationDataProvider.delete(resource, params);
      case AdminResource.users:
        return userDataProvider.delete(resource, params);
      case AdminResource.results:
        return resultDataProvider.delete(resource, params);
      default:
        throw NotImplementedError;
    }
  },
  deleteMany: async (resource, params) => {
    switch (resource) {
      case AdminResource.organizations:
        return organizationDataProvider.deleteMany(resource, params);
      case AdminResource.users:
        return userDataProvider.deleteMany(resource, params);
      case AdminResource.results:
        return resultDataProvider.deleteMany(resource, params);
      default:
        throw NotImplementedError;
    }
  },
};

export default dataProvider;
